import React, {useEffect,useState,useRef} from "react";
import ArrowIcon from './assets/Arrow 2.svg';
import './AddNewPricing.css';
import FadeLoader from "react-spinners/FadeLoader";
import axios from 'axios';

const AddNewPricing = ({
    pricingPlanData,
    handleCancelPricing,
    editPopup,
    setEditPopup,
    setIsPricingPopupOpen,
    onSaveSuccess,
    setLoader,
    setLoading,
    loading    
    }) => {
        const [isDefault, setIsDefault] = useState(pricingPlanData?.isDefault || "");
        const [location, setLocation] = useState(pricingPlanData?.location || "");
        const [startTime, setStartTime] = useState(pricingPlanData?.startTime || "");
        const [endTime, setEndTime] = useState(pricingPlanData?.endTime || "");
        const [duration, setDuration] = useState('');
        const [price, setPrice] = useState(pricingPlanData?.price || "");
        const [rateUnit, setRateUnit] = useState(pricingPlanData?.rateUnit || "");
        const [selectedDays, setSelectedDays] = useState([]);
        const [allDay, setAllDay] = useState(false);
        const [errors, setErrors] = useState({});
        const [locationSuggestions, setLocationSuggestions] = useState([]);
        const [showLocationSuggestions, setShowLocationSuggestions] = useState(false);
        const [isLocationSelected, setIsLocationSelected] = useState(false);
        const [pricingPlanName, setPlanName] = useState(pricingPlanData?.pricingPlanName || "");
        const hostPath = process.env.REACT_APP_API_BASE_URL;
        const hostHeader = process.env.REACT_APP_CUSTOM_HEADER;
        const wrapperRef = useRef(null);

        
        
        const formatTime = (date) => {
        const hours = (`${date.getHours()}`).padStart(2, '0');
        const minutes = (`${date.getMinutes()}`).padStart(2, '0');
        return `${hours}:${minutes}`;
        };

        function convertTo24Hour(timeString) {
            let t = timeString.trim().toUpperCase();
            if (!t.endsWith("AM") && !t.endsWith("PM")) {
                return t;
            }
            const isPM = t.endsWith("PM");
            t = t.replace(/AM|PM/, "").trim();

            let [hh, mm = "00"] = t.split(":");
            let hours = parseInt(hh, 10);
            let minutes = parseInt(mm, 10) || 0;

            if (isPM && hours < 12) hours += 12;      
            if (!isPM && hours === 12) hours = 0;     

            return String(hours).padStart(2, "0") + ":" + String(minutes).padStart(2, "0");
        }

        const days = [
        { id: 0, label: "Sun" },
        { id: 1, label: "Mon" },
        { id: 2, label: "Tue" },
        { id: 3, label: "Wed" },
        { id: 4, label: "Thu" },
        { id: 5, label: "Fri" },
        { id: 6, label: "Sat" }];

        const toggleDay = (dayId) => {
            setSelectedDays(prev => {
                let updatedDays;
                if (prev.includes(dayId)) {
                updatedDays = prev.filter(d => d !== dayId);
                } else {
                updatedDays = [...prev, dayId];
                }
                // Update allDay if all days are selected
                setAllDay(updatedDays.length === days.length);
                return updatedDays;
            });
        };
       
        const handleAllDayChange = () => {
            if (allDay) {
                setAllDay(false);
                setSelectedDays([]);     // Clear all days
            } else {
                setAllDay(true);
                setSelectedDays(days.map(d => d.id));   // Select all days
            }
        };

        const handleChange = (field, value) => {
            if (field === "pricingPlanName") {
                const regex = /^[A-Za-z\s]*$/;
            // Prevent space as first character
            if (value.length === 1 && value.startsWith(" ")) {
                return;
            }
                setPlanName(value);
                setErrors((prev) => ({
                    ...prev,
                    pricingPlanName: !value.trim()
                                ? "Pricing Plan Name is required."
                                : !regex.test(value)
                                ? "Enter alphabetic characters only"
                                : "",
                }));
            } 
        };

        const handleLocationChange = async (e) => {
            const { value } = e.target;
            setLocation(value);
            setIsLocationSelected(false); 
            if (value.trim().length > 2) {
                try {
                    const response = await axios.get(
                        `https://atlas.microsoft.com/search/address/json?subscription-key=EN5vcaicwC78zKi3M3980VVB1m7DuuN0vKaDMtYdjBg7daKhx3OTJQQJ99AHAC8vTIngVrqvAAAgAZMPLtXG&api-version=1.0&language=en-US&query=${value}&countrySet=US`
                    );
                    const results = response.data.results || [];
                    
                    // Filter valid US addresses with street info
                    const locSuggestions = results?.filter(result => result.address.countryCode === 'US' && result.address.streetNumber).map((result) => result.address);

                    setLocationSuggestions(locSuggestions);
                    setShowLocationSuggestions(true);
                } catch (error) {
                    console.error("Error fetching location suggestions:", error);
                }
            } else {
                setLocationSuggestions([]);
                setShowLocationSuggestions(false);
            }

            setErrors((prev) => ({
                ...prev,
                location: value ? "" : "Location is required.",
            }));
        };

        const handleLocationSelect = (selected) => {
            setLocation(selected.freeformAddress);
            setLocationSuggestions([]);
            setShowLocationSuggestions(false);
            setIsLocationSelected(true); 
        };



        const handleStartTimeChange = (event) => {
            const newStartTime = convertTo24Hour(event.target.value);
            setStartTime(newStartTime);
            updateStartAndEndTime(newStartTime, endTime);
        };

        const handleEndTimeChange = (event) => {
            const newEndTime = convertTo24Hour(event.target.value);
            setEndTime(newEndTime);
            updateStartAndEndTime(startTime, newEndTime);
        };

        const updateStartAndEndTime = (startTime, endTime) => {
            if (!startTime || !endTime) {
                return;
            }
            setDuration(calculateDuration(startTime, endTime));
        };

        const handleSubmit = async () => {
            setLoading(true);
            const newErrors = {};
            if (!pricingPlanName.trim()) newErrors.pricingPlanName = "Pricing Plan Name is required.";
            if (!location) newErrors.location = "Location is required.";

            let payload = {
                PricingPlanName: pricingPlanName,
                Location: location,
                Occurrence:selectedDays,
                Price:price,
                RateUnit:rateUnit,
                TimeRanges:[{
                    StartTime:startTime,
                    EndTime:endTime
                }],
                IsDefault: isDefault,
            };

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setLoading(false);
            return;
        }

        try {
            const url = editPopup
                ? `${hostPath}/api/UpdatePricingPlan`
                : `${hostPath}/api/AddNewPricingPlan`;

            const method = editPopup ? "PUT" : "POST";
            const requestPayload = editPopup
                ? {
                    id: pricingPlanData.id,
                    PricingPlanID:pricingPlanData.pricingPlanID,
                    PricingPlanName: pricingPlanName,
                    Location: location,
                    Occurrence: selectedDays,
                    Price: price,
                    RateUnit: rateUnit,
                    TimeRanges: [{
                        StartTime: startTime,
                        EndTime: endTime
                    }],
                    IsDefault: isDefault,
                    Status: pricingPlanData.status,
                    CreatedDate: pricingPlanData.createdDate,
                    LastUpdatedDate: pricingPlanData.lastUpdatedDate,
                    
                }
                : payload;
            const response = await fetch(url, {
                method,
                headers: {
                    "x-functions-key": hostHeader,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestPayload),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            setLoader(true);
            if (onSaveSuccess) {
                onSaveSuccess();
            } else {
             setIsPricingPopupOpen(false);
            }
            setEditPopup(false);
        } catch (error) {
            console.error("Error saving pricing plan:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (editPopup && pricingPlanData) {
            setPlanName(pricingPlanData.pricingPlanName || "");
            setLocation(pricingPlanData.location || "");
            setPrice(pricingPlanData.price || "");
            setRateUnit(pricingPlanData.rateUnit || "");
            setIsDefault(pricingPlanData.isDefault || "");
            if (pricingPlanData.location) {
            setIsLocationSelected(true);
            }
             if (Array.isArray(pricingPlanData.occurrence)) {
                setSelectedDays(pricingPlanData.occurrence || []);
                setAllDay(pricingPlanData.occurrence.length === days.length);
                } else {
                setSelectedDays([]);
                setAllDay(false);
                }
            if (pricingPlanData.timeRanges?.length > 0) {
                const sTime = pricingPlanData.timeRanges[0].startTime || "";
                const eTime = pricingPlanData.timeRanges[0].endTime || "";
                setStartTime(sTime);
                setEndTime(eTime);
                if (sTime && eTime) {
                    setDuration(calculateDuration(sTime, eTime));
                }
            }
        }
        else{
            const now = new Date();
            const defaultStartTimeStr = formatTime(now);
            const defaultEndTimeStr = formatTime(new Date(now.getTime() + 60 * 60 * 1000)); // +1 hr
            setStartTime(defaultStartTimeStr);
            setEndTime(defaultEndTimeStr);
            setDuration(calculateDuration(defaultStartTimeStr, defaultEndTimeStr));
        }
    }, [pricingPlanData, editPopup]);

    const isSaveEnabled = () => {
        if (
            !pricingPlanName.trim() ||
            !location.trim() ||
            !startTime ||
            !endTime ||
            !selectedDays.length ||
            !price ||
            !rateUnit||
            !isLocationSelected
        ) {
            return false;
        }
        if (errors.pricingPlanName || errors.location) {
            return false;
        }
        return true;
    };

    // Calculate duration between start and end times
    const calculateDuration = (start, end) => {
        if (start && end) {
            // Parse start time
            const [startHours, startMinutes] = start.split(':').map(Number);
            // Parse end time
            const [endHours, endMinutes] = end.split(':').map(Number);

            // Calculate total minutes
            const startTotalMinutes = startHours * 60 + startMinutes;
            const endTotalMinutes = endHours * 60 + endMinutes;

            let diff = endTotalMinutes - startTotalMinutes;

            if (diff < 0) {
                // If end time is before start time, assume the event spans to next day
                diff += 24 * 60;
            }

            const hours = Math.floor(diff / 60);
            const minutes = diff % 60;
            return `${hours}h ${minutes}min`;
        }
        return '';
    };

    const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setShowLocationSuggestions(false);
            }
        };
    
    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
        document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


return (
        <>
            {loading && (
                <div className="loader-overlay">
                    <FadeLoader />
                </div>
            )}

            <div className="createnewpricing-container">
                <p className="pricing-title">{editPopup ? "Edit Pricing Plan" : "Create New Pricing Plan"}</p>
                <div className="pricing-input-container">
                    <label htmlFor="pricingPlanName" className="pricing-label">
                        Pricing Plan Name<span className="mandatorymark">*</span>
                    </label>
                    <input
                        type="text"
                        id="pricingPlanName"
                        maxLength={100}
                        placeholder="e.g., weekday plan"
                        className="pricing-input"
                        value={pricingPlanName}
                        onChange={(e) => handleChange("pricingPlanName", e.target.value)}
                    />
                    {errors.pricingPlanName && <p className="error-message">{errors.pricingPlanName}</p>}
                </div>

                <div className="pricing-input-container">
                    <label htmlFor="location" className="pricing-label">
                        Enter the Location<span className="mandatorymark">*</span>
                    </label>
                    <div className="input-location" ref={wrapperRef}>
                        <input
                            type="text"
                            id="location"
                            placeholder="e.g., Rural"
                            value={location}
                            onChange={handleLocationChange}
                            onFocus={() => setShowLocationSuggestions(locationSuggestions.length > 0)}
                            autoComplete="off"
                        />
                        {showLocationSuggestions && locationSuggestions.length > 0 && (
                            <ul className="search-results-owner">
                                {locationSuggestions.map((result, index) => (
                                    <li key={index} onClick={() => handleLocationSelect(result)}>
                                        {result.freeformAddress}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                    {errors.location && <p className="error-message">{errors.location}</p>}
                </div>
                <div>
                        <div className="pricing-custom-recurrence-icon-wrapper" style={{ marginRight: '10px' }}>
                            <label htmlFor="time" className="pricing-label" style={{ textAlign: 'left', paddingTop: '15px' }}>Time<span className="mandatorymark">*</span></label>
                        </div>
                        <div className="pricing-custom-time-group">
                            <div className="pricing-custom-input-container">
                                <input
                                    type="time"
                                    className="pricing-custom-input"
                                    value={startTime || ''}
                                    onChange={handleStartTimeChange}
                                    placeholder="Select start time"
                                />
                            </div>
                            <div className="pricing-custom-arrow-container">
                                <img
                                    src={ArrowIcon}
                                    alt="Arrow Icon"
                                    className="pricing-custom-arrow-icon"
                                />
                            </div>
                            <div className="pricing-custom-input-container">
                                <input
                                    type="time"
                                    className="pricing-custom-input"
                                    value={endTime || ''}
                                    onChange={handleEndTimeChange}
                                    placeholder="Select end time"
                                />
                            </div>
                            <span className="custom-duration-text"
                                    style={{
                                        marginLeft: '2px',
                                        marginRight: '2px',
                                        fontSize: '12px',
                                    }}
                                >
                                    {duration}
                            </span>
                        </div>
                    </div>

                    <div className="pricing-input-container">
                        <label className="pricing-label">Select Applicable Days<span className="mandatorymark">*</span></label>
                        <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
                           {days.map(day => (
                            <button
                                key={day.id}
                                type="button"
                                onClick={() => toggleDay(Number(day.id))}
                                style={{
                                padding: '6px 10px',
                                borderRadius: '4px',
                                backgroundColor: selectedDays.includes(day.id) ? '#007bff' : '#eee',
                                color: selectedDays.includes(day.id) ? '#fff' : '#000',
                                border: 'none',
                                cursor: 'pointer'
                                }}
                            >
                                 {day.label}
                            </button>
                            ))}
                        </div>
                    </div>

                    <div className="all-days-container">
                        <input  type="checkbox" id="allDay" className="all-days-checkbox" checked={allDay} onChange={handleAllDayChange}/>
                        <label htmlFor="allDay">All Days</label>
                    </div>
                    <div className="all-days-container">
                        <input type="checkbox" id="defaultPlan" className="default-checkbox" checked={isDefault} onChange={(e) => setIsDefault(e.target.checked)}/>
                        <label htmlFor="defaultPlan">Make Default Plan</label>
                    </div>
                    <div className="price-section">
                        <label className="pricing-label">Enter the Price<span className="mandatorymark">*</span></label>
                        <div className="price-input-group">
                            <div className="price-input-wrapper">
                                <span className="currency-symbol">$</span>
                                <input type="number" className="price-input" min="0" value={price} onChange={(e) => setPrice(e.target.value)}/>
                            </div>
                            <div className="radio-group">
                            <label className="radio-option">
                                <input type="radio" name="rateUnit" value="min" checked={rateUnit === "min"}
                                    onChange={(e) => setRateUnit(e.target.value)}/>Per min
                            </label>
                            <label className="radio-option">
                                <input type="radio" name="rateUnit" value="hour" checked={rateUnit === "hour"}
                                    onChange={(e) => setRateUnit(e.target.value)}/>Per hour
                            </label>
                            <label className="radio-option">
                                <input type="radio" name="rateUnit" value="day" checked={rateUnit === "day"}
                                    onChange={(e) => setRateUnit(e.target.value)}/>Per day
                            </label>
                            </div>
                        </div>
                    </div>
                   
                <div className="pricing-buttons">
                    <button className="cancel-btn" onClick={handleCancelPricing}>
                        Cancel
                    </button>
                    <button
                        className={isSaveEnabled() ? "add-pricing-btn" : "cancel-pricing-btn"}
                        onClick={handleSubmit} disabled={!isSaveEnabled()}
                        style={{ cursor: isSaveEnabled() ? "pointer" : "not-allowed", color: isSaveEnabled() ? "#fff" : "#000000", }}
                    >
                        {editPopup ? "Update" : "Confirm"}
                    </button>
                </div>
            </div>
        </>
    );
}
export default AddNewPricing;